export class GraphOptions {
  interval: string = '';
  isCandleStick: boolean = false;
  isFirstLoad: boolean = true;
  YAxisText: string = '';
}
